/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityCustomTag } from './FacilityCustomTag';
import {
    FacilityCustomTagFromJSON,
    FacilityCustomTagFromJSONTyped,
    FacilityCustomTagToJSON,
    FacilityCustomTagToJSONTyped,
} from './FacilityCustomTag';

/**
 * 
 * @export
 * @interface FindAllFacilityCustomTags200Response
 */
export interface FindAllFacilityCustomTags200Response {
    /**
     * 
     */
    data?: Array<FacilityCustomTag>;
}

/**
 * Check if a given object implements the FindAllFacilityCustomTags200Response interface.
 */
export function instanceOfFindAllFacilityCustomTags200Response(value: object): value is FindAllFacilityCustomTags200Response {
    return true;
}

export function FindAllFacilityCustomTags200ResponseFromJSON(json: any): FindAllFacilityCustomTags200Response {
    return FindAllFacilityCustomTags200ResponseFromJSONTyped(json, false);
}

export function FindAllFacilityCustomTags200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllFacilityCustomTags200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FacilityCustomTagFromJSON)),
    };
}

export function FindAllFacilityCustomTags200ResponseToJSON(json: any): FindAllFacilityCustomTags200Response {
    return FindAllFacilityCustomTags200ResponseToJSONTyped(json, false);
}

export function FindAllFacilityCustomTags200ResponseToJSONTyped(value?: FindAllFacilityCustomTags200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FacilityCustomTagToJSON)),
    };
}

